import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
  required: {
    id: 'errors.validation.required',
    defaultMessage: 'Required',
  },
  email: {
    id: 'errors.validation.invalidEmail',
    defaultMessage: 'Invalid email address',
  },
  sameAs: {
    id: 'error.not_match',
    defaultMessage: 'No match',
  },
  notANumber: {
    id: 'error.not_a_number',
    defaultMessage: 'Invalid number',
  },
});

export default {
  validationMessages,
};
